import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { DebugToggle, ToggleType } from './internal.models';
import { RootState } from 'app/store';
import { logout } from 'features/auth/authenticationSlice';
import { PURGE } from 'redux-persist';

interface InternalSettingsState {
  debugToggles: DebugToggle[];
}

const initialState: InternalSettingsState = {
  debugToggles: [
    {
      name: ToggleType.POCToggle,
      enabled: false,
      type: ToggleType.POCToggle
    },
    {
      name: ToggleType.DisplayConversionId,
      enabled: false,
      type: ToggleType.DisplayConversionId
    },
    {
      name: ToggleType.DisplayRevenueId,
      enabled: false,
      type: ToggleType.DisplayRevenueId
    },
    {
      name: ToggleType.DisplayOpportunityId,
      enabled: false,
      type: ToggleType.DisplayOpportunityId
    },
    {
      name: ToggleType.DisplayPathsTimeToConversion,
      enabled: false,
      type: ToggleType.DisplayPathsTimeToConversion
    },
    {
      name: ToggleType.DisplayPOCDashboardTiles,
      enabled: false,
      type: ToggleType.DisplayPOCDashboardTiles
    },
    {
      name: ToggleType.DisplayNewSideBar,
      enabled: false,
      type: ToggleType.DisplayNewSideBar
    }
  ]
};

const internalSettingsSlice = createSlice({
  name: 'internalSettingsToggle',
  initialState,
  reducers: {
    onDebugToggleChanged: (state, action: PayloadAction<DebugToggle>) => {
      const index = state.debugToggles.findIndex(
        (item) => item.name === action.payload.name
      );
      if (index !== -1) {
        state.debugToggles[index].enabled = !action.payload.enabled;
      } else {
        console.error(
          `Debug toggle with name '${action.payload.name}' not found.`
        );
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      return initialState;
    });
    builder.addCase(PURGE, () => initialState);
  }
});

const { actions, reducer } = internalSettingsSlice;

export const { onDebugToggleChanged } = actions;

const selectSelf = (state: RootState) => state.internalSettings;

export const allDebugToggles = createSelector(
  selectSelf,
  (state: InternalSettingsState) =>
    state.debugToggles.filter(
      (toggle) => toggle.type !== ToggleType.AdvancedReports
    )
);

export const debugToggleByType = createSelector(
  (state: RootState) => state.internalSettings.debugToggles,
  (_: any, type: ToggleType) => type,
  (debugToggles: DebugToggle[], type: ToggleType) =>
    debugToggles.find((debugToggle) => debugToggle.type === type)
);

export default reducer;
